// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;

import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123'),
	() => import('./nodes/124'),
	() => import('./nodes/125'),
	() => import('./nodes/126'),
	() => import('./nodes/127'),
	() => import('./nodes/128'),
	() => import('./nodes/129'),
	() => import('./nodes/130'),
	() => import('./nodes/131'),
	() => import('./nodes/132'),
	() => import('./nodes/133'),
	() => import('./nodes/134'),
	() => import('./nodes/135'),
	() => import('./nodes/136'),
	() => import('./nodes/137'),
	() => import('./nodes/138'),
	() => import('./nodes/139'),
	() => import('./nodes/140'),
	() => import('./nodes/141'),
	() => import('./nodes/142'),
	() => import('./nodes/143'),
	() => import('./nodes/144'),
	() => import('./nodes/145'),
	() => import('./nodes/146'),
	() => import('./nodes/147'),
	() => import('./nodes/148'),
	() => import('./nodes/149'),
	() => import('./nodes/150'),
	() => import('./nodes/151'),
	() => import('./nodes/152'),
	() => import('./nodes/153'),
	() => import('./nodes/154'),
	() => import('./nodes/155'),
	() => import('./nodes/156'),
	() => import('./nodes/157'),
	() => import('./nodes/158'),
	() => import('./nodes/159'),
	() => import('./nodes/160'),
	() => import('./nodes/161'),
	() => import('./nodes/162'),
	() => import('./nodes/163'),
	() => import('./nodes/164'),
	() => import('./nodes/165'),
	() => import('./nodes/166'),
	() => import('./nodes/167'),
	() => import('./nodes/168'),
	() => import('./nodes/169'),
	() => import('./nodes/170'),
	() => import('./nodes/171'),
	() => import('./nodes/172'),
	() => import('./nodes/173'),
	() => import('./nodes/174'),
	() => import('./nodes/175'),
	() => import('./nodes/176'),
	() => import('./nodes/177'),
	() => import('./nodes/178'),
	() => import('./nodes/179'),
	() => import('./nodes/180'),
	() => import('./nodes/181'),
	() => import('./nodes/182'),
	() => import('./nodes/183'),
	() => import('./nodes/184'),
	() => import('./nodes/185'),
	() => import('./nodes/186'),
	() => import('./nodes/187'),
	() => import('./nodes/188'),
	() => import('./nodes/189'),
	() => import('./nodes/190'),
	() => import('./nodes/191'),
	() => import('./nodes/192'),
	() => import('./nodes/193'),
	() => import('./nodes/194'),
	() => import('./nodes/195'),
	() => import('./nodes/196'),
	() => import('./nodes/197'),
	() => import('./nodes/198'),
	() => import('./nodes/199'),
	() => import('./nodes/200'),
	() => import('./nodes/201'),
	() => import('./nodes/202'),
	() => import('./nodes/203'),
	() => import('./nodes/204'),
	() => import('./nodes/205'),
	() => import('./nodes/206'),
	() => import('./nodes/207'),
	() => import('./nodes/208'),
	() => import('./nodes/209'),
	() => import('./nodes/210'),
	() => import('./nodes/211'),
	() => import('./nodes/212'),
	() => import('./nodes/213'),
	() => import('./nodes/214'),
	() => import('./nodes/215'),
	() => import('./nodes/216'),
	() => import('./nodes/217'),
	() => import('./nodes/218'),
	() => import('./nodes/219'),
	() => import('./nodes/220'),
	() => import('./nodes/221'),
	() => import('./nodes/222'),
	() => import('./nodes/223'),
	() => import('./nodes/224'),
	() => import('./nodes/225'),
	() => import('./nodes/226'),
	() => import('./nodes/227'),
	() => import('./nodes/228'),
	() => import('./nodes/229'),
	() => import('./nodes/230'),
	() => import('./nodes/231'),
	() => import('./nodes/232'),
	() => import('./nodes/233'),
	() => import('./nodes/234'),
	() => import('./nodes/235'),
	() => import('./nodes/236'),
	() => import('./nodes/237'),
	() => import('./nodes/238'),
	() => import('./nodes/239'),
	() => import('./nodes/240'),
	() => import('./nodes/241'),
	() => import('./nodes/242'),
	() => import('./nodes/243'),
	() => import('./nodes/244'),
	() => import('./nodes/245'),
	() => import('./nodes/246'),
	() => import('./nodes/247'),
	() => import('./nodes/248'),
	() => import('./nodes/249'),
	() => import('./nodes/250'),
	() => import('./nodes/251'),
	() => import('./nodes/252'),
	() => import('./nodes/253'),
	() => import('./nodes/254'),
	() => import('./nodes/255'),
	() => import('./nodes/256'),
	() => import('./nodes/257'),
	() => import('./nodes/258'),
	() => import('./nodes/259'),
	() => import('./nodes/260'),
	() => import('./nodes/261'),
	() => import('./nodes/262'),
	() => import('./nodes/263'),
	() => import('./nodes/264'),
	() => import('./nodes/265'),
	() => import('./nodes/266'),
	() => import('./nodes/267'),
	() => import('./nodes/268'),
	() => import('./nodes/269'),
	() => import('./nodes/270'),
	() => import('./nodes/271'),
	() => import('./nodes/272'),
	() => import('./nodes/273'),
	() => import('./nodes/274'),
	() => import('./nodes/275'),
	() => import('./nodes/276'),
	() => import('./nodes/277'),
	() => import('./nodes/278'),
	() => import('./nodes/279'),
	() => import('./nodes/280'),
	() => import('./nodes/281'),
	() => import('./nodes/282'),
	() => import('./nodes/283'),
	() => import('./nodes/284'),
	() => import('./nodes/285'),
	() => import('./nodes/286')
];

export const server_loads = [0,30,5,23,27,28,29,9,3,16,4];

export const dictionary = {
		"/(marketing)": [~210,[30]],
		"/(marketing)/academics": [229,[30]],
		"/(auth)/(signin)/account-migration/verify/[token]": [37,[2]],
		"/(auth)/(signin)/account-pending": [38,[2]],
		"/(marketing)/(redirects)/(utm)/andreas": [211,[31]],
		"/(dash)/apps/[workspace]/[environment]": [52,[5],[6]],
		"/(dash)/apps/[workspace]/[environment]/deployed/[name]": [54,[5],[6]],
		"/(dash)/apps/[workspace]/[environment]/v2": [55,[5],[6]],
		"/(dash)/apps/[workspace]/[environment]/[appId]": [53,[5],[6]],
		"/(marketing)/articles": [230,[30]],
		"/(auth)/(signin)/authorize": [39,[2]],
		"/(marketing)/(redirects)/(utm)/bigboxswe": [212,[31]],
		"/(marketing)/blog": [~231,[30,32]],
		"/(marketing)/blog/[slug]": [~232,[30,32]],
		"/(marketing)/(redirects)/brand": [218,[31]],
		"/(microsites)/c-function": [261],
		"/(marketing)/(redirects)/careers": [219,[31]],
		"/(marketing)/changelog": [~233,[30]],
		"/(marketing)/changelog/[slug]": [~234,[30]],
		"/(dash)/clusters/[workspace]/[environment]": [56,[5],[6]],
		"/(marketing)/(redirects)/(utm)/cometeer": [213,[31]],
		"/(marketing)/company": [~235,[30]],
		"/(dash)/containers/[workspace]/[environment]": [57,[5],[6]],
		"/(dash)/containers/[workspace]/[environment]/[tab=containersTab]": [58,[5],[6]],
		"/(marketing)/(redirects)/credits": [220,[31]],
		"/(marketing)/customers": [~236,[30]],
		"/(marketing)/(redirects)/(utm)/dancleary": [214,[31]],
		"/(dash)/(redirects)/dashboard": [49,[7]],
		"/(docs)/docs": [196,[20],[21]],
		"/(docs)/docs/cli/latest/[...id]": [~198,[20,22,23],[21]],
		"/(docs)/docs/devin": [199,[20],[21]],
		"/(docs)/docs/examples": [200,[20,24],[21]],
		"/(docs)/docs/examples/[...id]": [201,[20,24],[21]],
		"/(docs)/docs/guide/[...id]": [202,[20,25],[21]],
		"/(docs)/docs/sdk/go/latest/[...id]": [~203,[20,26,27],[21]],
		"/(docs)/docs/sdk/go/releases": [~204,[20,26],[21]],
		"/(docs)/docs/sdk/js/latest/[...id]": [~205,[20,26,28],[21]],
		"/(docs)/docs/sdk/js/releases": [~206,[20,26],[21]],
		"/(docs)/docs/sdk/py/latest/[...id]": [~207,[20,26,29],[21]],
		"/(docs)/docs/sdk/py/releases": [~208,[20,26],[21]],
		"/(docs)/docs/[...fallback]": [197,[20],[21]],
		"/(dash)/endpoints/[workspace]/[environment]": [59,[5],[6]],
		"/(dash)/endpoints/[workspace]/[environment]/create": [61,[5],[6]],
		"/(dash)/endpoints/[workspace]/[environment]/[endpointId]": [60,[5],[6]],
		"/(dash)/evaluations/[workspace]/[environment]": [62,[5,8],[6]],
		"/(dash)/evaluations/[workspace]/[environment]/create": [64,[5,8],[6]],
		"/(dash)/evaluations/[workspace]/[environment]/[jobId]": [63,[5,8],[6]],
		"/(marketing)/(redirects)/events": [221,[31]],
		"/(docs)/examples": [209],
		"/(microsites)/glm-5-endpoint": [~262],
		"/(marketing)/(redirects)/glossary": [222,[31]],
		"/(marketing)/(redirects)/(utm)/gopher": [215,[31]],
		"/(microsites)/gpu-glossary": [263,[34],[35]],
		"/(microsites)/gpu-glossary/[...id]": [264,[34],[35]],
		"/(dash)/(redirects)/home": [50,[7]],
		"/(dash)/id/[id]": [65,[5],[6]],
		"/(dash)/images/[workspace]/[environment]": [66,[5],[6]],
		"/(dash)/internal": [67,[9]],
		"/(dash)/internal/access-requests": [68,[9]],
		"/(dash)/internal/access-requests/audit": [69,[9]],
		"/(dash)/internal/accounts": [70,[9]],
		"/(dash)/internal/accounts/[...rest]": [71,[9]],
		"/(dash)/internal/batch": [72,[9]],
		"/(dash)/internal/billing-groups": [73,[9]],
		"/(dash)/internal/billing-groups/[groupId]": [74,[9]],
		"/(dash)/internal/bizops-audit-logs": [75,[9]],
		"/(dash)/internal/capacity-probes": [76,[9]],
		"/(dash)/internal/clusters": [77,[9]],
		"/(dash)/internal/credit-codes": [78,[9]],
		"/(dash)/internal/cube-memorial": [79,[9]],
		"/(dash)/internal/customer-onboarding": [80,[9]],
		"/(dash)/internal/design": [81,[9,10]],
		"/(dash)/internal/design/colors": [82,[9,10]],
		"/(dash)/internal/design/colors/dataviz": [83,[9,10]],
		"/(dash)/internal/design/components": [84,[9,10]],
		"/(dash)/internal/design/components/button": [85,[9,10]],
		"/(dash)/internal/design/components/checkbox": [86,[9,10]],
		"/(dash)/internal/design/components/dropdown": [87,[9,10]],
		"/(dash)/internal/design/graphics": [88,[9,10]],
		"/(dash)/internal/design/typography": [89,[9,10]],
		"/(dash)/internal/flash": [90,[9]],
		"/(dash)/internal/flash/[hostname]": [91,[9]],
		"/(dash)/internal/fleet-bench": [92,[9]],
		"/(dash)/internal/fraud": [93,[9]],
		"/(dash)/internal/gpu-capacity-management": [94,[9]],
		"/(dash)/internal/gpu-health": [95,[9]],
		"/(dash)/internal/gpu-shortfall": [96,[9]],
		"/(dash)/internal/gpus": [97,[9]],
		"/(dash)/internal/incident-management": [98,[9]],
		"/(dash)/internal/leased-notifiers": [99,[9]],
		"/(dash)/internal/logs": [100,[9]],
		"/(dash)/internal/lookup": [101,[9,11]],
		"/(dash)/internal/lookup/[id]": [102,[9,11]],
		"/(dash)/internal/machine-manager": [103,[9]],
		"/(dash)/internal/margins": [104,[9]],
		"/(dash)/internal/oauth-clients": [105,[9]],
		"/(dash)/internal/plans": [106,[9]],
		"/(dash)/internal/plans/change-workspace-plan": [108,[9]],
		"/(dash)/internal/plans/new": [109,[9]],
		"/(dash)/internal/plans/[plan_id]": [107,[9]],
		"/(dash)/internal/queues": [110,[9]],
		"/(dash)/internal/reservations": [111,[9]],
		"/(dash)/internal/resources": [112,[9]],
		"/(dash)/internal/resources/fullscreen": [113],
		"/(dash)/internal/sandbox-capacity-supply": [114,[9]],
		"/(dash)/internal/solver": [115,[9]],
		"/(dash)/internal/training-capacity": [116,[9]],
		"/(dash)/internal/users": [117,[9,12]],
		"/(dash)/internal/users/[userId]": [118,[9,12,13]],
		"/(dash)/internal/users/[userId]/administration": [119,[9,12,13]],
		"/(dash)/internal/users/[userId]/identity-providers": [120,[9,12,13]],
		"/(dash)/internal/users/[userId]/memberships": [121,[9,12,13]],
		"/(dash)/internal/vuln-portal": [122,[9]],
		"/(dash)/internal/worker-timeline": [123,[9]],
		"/(dash)/internal/workers": [124,[9]],
		"/(dash)/internal/workspaces": [125,[9,14]],
		"/(dash)/internal/workspaces/[workspace]": [126,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/access": [127,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/billing": [128,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/credits": [129,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/egress": [130,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/environments": [131,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/invites": [132,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/invoices": [133,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/limits-and-overrides": [134,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/members": [135,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/plan-history": [137,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/plan": [136,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/reservations": [138,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/resources": [139,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/stripe-controls": [140,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/usage": [141,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/workers": [142,[9,14,15]],
		"/(marketing)/(redirects)/jobs": [223,[31]],
		"/(marketing)/legal/dpa": [237,[30]],
		"/(marketing)/legal/event": [238,[30]],
		"/(marketing)/legal/privacy-policy": [239,[30]],
		"/(marketing)/legal/terms-effective-date-march-2024": [241,[30]],
		"/(marketing)/legal/terms-effective-date-october-2025": [242,[30]],
		"/(marketing)/legal/terms": [240,[30]],
		"/(marketing)/library": [~243,[30]],
		"/(marketing)/library/[providerSlug]/[modelSlug]": [~244,[30]],
		"/(microsites)/llm-almanac": [265,[36]],
		"/(microsites)/llm-almanac/advisor": [266,[36]],
		"/(microsites)/llm-almanac/block-quants/[[format]]": [267,[36]],
		"/(microsites)/llm-almanac/how-to-benchmark": [268,[36]],
		"/(microsites)/llm-almanac/quant-formats/[[encoded]]": [269,[36]],
		"/(microsites)/llm-almanac/spec-dec-roofline": [270,[36]],
		"/(microsites)/llm-almanac/summary": [271,[36]],
		"/(microsites)/llm-almanac/token-timing-simulator": [272,[36]],
		"/(microsites)/llm-almanac/workloads": [273,[36]],
		"/(auth)/(signin)/login": [40,[2]],
		"/(auth)/(signin)/login/sso": [41,[2]],
		"/(dash)/logs/[workspace]/[environment]": [143,[5],[6]],
		"/(dash)/logs/[workspace]/[environment]/[appId]": [144,[5],[6]],
		"/(marketing)/(redirects)/lp/academics": [224,[31]],
		"/(marketing)/(redirects)/lp/startups": [225,[31]],
		"/notebooks": [283],
		"/(dash)/notebooks/new/[...external_url]": [146,[5],[6]],
		"/notebooks/[workspace]/_/[id]": [286],
		"/notebooks/[workspace]/[id=likelyNotebookId]": [285],
		"/(dash)/notebooks/[workspace]/[environment]": [145,[5],[6]],
		"/notebooks/[workspace]/[environment]/[notebookId]": [284],
		"/(auth)/oauth/consent/[oauthRequestId]": [43,[3]],
		"/(marketing)/partners": [245,[30]],
		"/(marketing)/(redirects)/playground/[...rest]": [226,[31]],
		"/(marketing)/(redirects)/(utm)/pragmatic": [216,[31]],
		"/(marketing)/pricing": [246,[30]],
		"/(marketing)/products/batch": [247,[30]],
		"/(marketing)/products/inference": [~248,[30]],
		"/(marketing)/(redirects)/products/notebooks": [227,[31]],
		"/(marketing)/products/platform": [~249,[30]],
		"/(marketing)/products/sandboxes": [~250,[30]],
		"/(marketing)/products/training": [~251,[30]],
		"/(microsites)/runtime": [274],
		"/(microsites)/runtime/archive": [275],
		"/(microsites)/runtime/archive/agenda": [276],
		"/(microsites)/runtime/archive/map": [277],
		"/(microsites)/runtime/lab": [278],
		"/(microsites)/runtime/lab/badge": [279],
		"/(microsites)/runtime/lab/badge/card": [280],
		"/(microsites)/runtime/partner": [281],
		"/(microsites)/runtime/speakers": [282],
		"/(dash)/sandboxes/[workspace]/[environment]": [147,[5],[6]],
		"/(dash)/secrets/[workspace]/[environment]": [148,[5],[6]],
		"/(dash)/secrets/[workspace]/[environment]/create": [150,[5],[6]],
		"/(dash)/secrets/[workspace]/[environment]/[name]": [149,[5],[6]],
		"/(dash)/settings": [151,[16],[17]],
		"/(dash)/settings/[[workspace]]/access-controls": [157,[16,18,19],[17]],
		"/(dash)/settings/[[workspace]]/access-controls/environments": [158,[16,18,19],[17]],
		"/(dash)/settings/[[workspace]]/access-grants": [159,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/audit-logs": [160,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/billing": [161,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/custom-domains": [162,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/(redirects)/domains": [152,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/environments": [163,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/image-builder-version": [164,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/(redirects)/image-config": [153,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/limits": [165,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/metrics": [166,[16,18],[17]],
		"/(dash)/settings/notifications": [185,[16],[17]],
		"/(dash)/settings/[[workspace]]/page-an-engineer": [167,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/plans": [168,[16,18],[17]],
		"/(dash)/settings/profile": [186,[16],[17]],
		"/(dash)/settings/[[workspace]]/proxies": [169,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/proxy-auth-tokens": [170,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/(redirects)/proxy": [154,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/(redirects)/slack-integration": [155,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/slack-notifications": [171,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/tokens": [172,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/tokens/api-tokens": [173,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/tokens/member-tokens": [174,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/tokens/service-users": [175,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/usage": [176,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/webhooks": [177,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/workspace-management": [178,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/workspace-management/environments": [179,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/workspace-management/environments/all": [180,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/workspace-management/environments/workspace-defaults": [181,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/workspace-management/groups": [182,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/workspace-management/identity-and-provisioning": [183,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/(redirects)/workspace-management/limits": [156,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/workspace-management/members": [184,[16,18],[17]],
		"/(dash)/settings/workspaces": [187,[16],[17]],
		"/(auth)/(signin)/signup": [42,[2]],
		"/(dash)/slack-link-workspace/[[workspace]]": [188,[5],[6]],
		"/(marketing)/(redirects)/slack": [228,[31]],
		"/(marketing)/solutions/audio": [252,[30]],
		"/(marketing)/solutions/coding-agents": [253,[30]],
		"/(marketing)/solutions/comp-bio": [254,[30]],
		"/(marketing)/solutions/image-and-video": [255,[30]],
		"/(marketing)/solutions/llm": [256,[30]],
		"/(marketing)/startups": [257,[30]],
		"/(dash)/storage/[workspace]/[environment]": [189,[5],[6]],
		"/(dash)/storage/[workspace]/[environment]/dicts": [191,[5],[6]],
		"/(dash)/storage/[workspace]/[environment]/nfs": [192,[5],[6]],
		"/(dash)/storage/[workspace]/[environment]/queues": [193,[5],[6]],
		"/(dash)/storage/[workspace]/[environment]/volumes": [194,[5],[6]],
		"/(dash)/storage/[workspace]/[environment]/volumes/[name]/[...dirName]": [195,[5],[6]],
		"/(dash)/storage/[workspace]/[environment]/[name]/[...dirName]": [190,[5],[6]],
		"/(marketing)/(redirects)/(utm)/t3gg": [217,[31]],
		"/(auth)/token-flow/[tokenFlowId]": [44,[4]],
		"/(marketing)/use-cases": [258,[30]],
		"/(marketing)/use-cases/[usecase]": [259,[30]],
		"/(marketing)/v2/components-test": [260,[33]],
		"/(dash)/(redirects)/[workspace=workspace]/[environment]/apps/[...rest]": [45,[7]],
		"/(dash)/(redirects)/[workspace=workspace]/[environment]/logs/[...rest]": [46,[7]],
		"/(dash)/(redirects)/[workspace=workspace]/[environment]/secrets/[...rest]": [47,[7]],
		"/(dash)/(redirects)/[workspace=workspace]/[environment]/storage/[...rest]": [48,[7]],
		"/(dash)/[fallback=dash]/[...rest]": [51,[5],[6]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);